import React, { Component, ReactNode } from "react";
import classnames from "classnames";
import { observable } from "mobx";
import { observer } from "mobx-react";

import * as styles from "./ContentTabs.scss";
import { ContentTabsButton } from "./ContentTabsButton";

export interface IContentTab {
    name: string;
    content: ReactNode;
}

export interface IContentTabsProps {
    tabs: IContentTab[];
    className?: string;
    buttonContainerClassName?: string;
    tabClassName?: string;
}

@observer
export class ContentTabs extends Component<IContentTabsProps> {
    @observable
    public activeTabIndex: number = 0;

    public render() {
        const { tabs, className, buttonContainerClassName, tabClassName } =
            this.props;

        return (
            <div
                className={classnames(
                    styles["content-tabs"],
                    className && className,
                )}
            >
                <div
                    className={classnames(
                        styles["button-container"],
                        buttonContainerClassName && buttonContainerClassName,
                    )}
                >
                    {tabs.map(({ name }, i) => (
                        <ContentTabsButton
                            key={i}
                            index={i}
                            active={i === this.activeTabIndex}
                            name={name}
                            onActivateTab={this.onActivateTab}
                        />
                    ))}
                </div>
                <div
                    className={classnames(
                        styles["tab-container"],
                        tabClassName && tabClassName,
                    )}
                >
                    {tabs.map((tab, i) => (
                        <div
                            className={classnames(
                                styles.tab,
                                i === this.activeTabIndex && styles.active,
                            )}
                            key={i}
                        >
                            {tab.content}
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    private onActivateTab = (i: number) => {
        this.activeTabIndex = i;
    };
}
